<template>
  <div class="echarts">
    <div style="width: 100; height: 100%" id="idMap" ref="allMap"></div>
    <div class="mapChoose" v-show="goBack">
      <span>
        <span class="title" @click="chooseArea()">
          <i>
            <svg
              width="10px"
              height="14px"
              viewBox="0 0 10 14"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="BI报表"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
              >
                <g
                  id="BI首页"
                  transform="translate(-524.000000, -230.000000)"
                  fill="#FFFFFF"
                  fill-rule="nonzero"
                >
                  <g
                    id="地图数据"
                    transform="translate(509.000000, 220.000000)"
                  >
                    <g id="编组-14" transform="translate(5.000000, 0.000000)">
                      <g id="编组-15">
                        <g id="编组-2">
                          <g
                            id="返回_export"
                            transform="translate(10.000000, 10.000000)"
                          >
                            <g
                              id="返回"
                              transform="translate(1.500000, 1.000000)"
                            >
                              <path
                                d="M6.22593882,11.2102837 L0.992182764,5.97652768 L6.22593882,0.742771622 C6.38917814,0.579532298 6.39149475,0.304754963 6.22344506,0.136718888 C6.05422343,-0.0325027388 5.78405206,-0.0324482333 5.6173787,0.134225124 L0.13539094,5.61619926 C0.040573402,5.7110168 4.63423295e-05,5.84345881 0.0156630282,5.97074979 C-0.00431433771,6.10065716 0.0357766646,6.23722821 0.13539094,6.33684248 L5.6173787,11.8188302 C5.78061802,11.9820696 6.05539536,11.9843862 6.22344506,11.8163365 C6.39266668,11.6471149 6.39259855,11.3769435 6.22593882,11.2102837 L6.22593882,11.2102837 Z"
                                id="路径"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </i>
          返回
        </span>
        <!-- <span class="icon" v-show="index + 1 != parentInfo.length">></span> -->
      </span>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import resize from "./mixins/resize";
import mapCode from "./mixins/mapCode";
import {
  GetCompanyIncomeAmount,
  GetCompanyPerformanceByProvince,
} from "@/api/api";
export default {
  name: "allMap",
  mixins: [resize],
  mapCode: [mapCode],
  data() {
    return {
      myCharts: null,
      urlData: "",
      geoJson: {
        features: [],
      },
      parentInfo: [
        {
          RegionName: "全国",
          code: 100000,
        },
      ],
      goBack: false,
      timeTitle: [],
      RegionName: [],
      RegionLineData: [],
      cityValue: [],
      cityCode: [],
      maxVal: 0,
      sliceCity: "",
      sliceYear: "",
      currentYear: "",
      currentLocationId: "",
      coordData: [],
    };
  },
  mounted() {
    //   this.cityNameData();
    var that = this;
    that.getGeoJson(100000);
  },

  methods: {
    getGeoJson(adcode) {
      this.timeTitle = [];
      this.RegionName = [];
      this.RegionLineData = [];
      this.cityValue = [];
      if (adcode != 0) {
        GetCompanyIncomeAmount({ ticket: this.urlData }).then((res) => {
          this.timeTitle = res.Data.Years;
          res.Data.IncomeAmountList.forEach((e) => {
            this.RegionName.push(e);
          });

          res.Data.IncomeAmountAllDataList.forEach((e) => {
            this.RegionLineData.push(e);
          });

          res.Data.ProvinceList.forEach((e) => {
            this.cityValue.push(e);
          });

          let that = this;
          AMapUI.loadUI(["geo/DistrictExplorer"], (DistrictExplorer) => {
            //   debugger

            var districtExplorer = new DistrictExplorer();
            districtExplorer.loadAreaNode(adcode, function (error, areaNode) {
              if (error) {
                return;
              }
              let Json = areaNode.getSubFeatures();

              if (Json.length > 0) {
                that.geoJson.features = Json;
              } else if (Json.length === 0) {
                that.geoJson.features = that.geoJson.features.filter(
                  (item) => item.properties.adcode == adcode
                );
                if (that.geoJson.features.length === 0) return;
              }
              if (adcode == 100000) {
                that.getMapData();
              } else {
                // that.getMapData();
                //下钻子查询
                // debugger;
                that.cityNameData();
              }
            });
          });
        });
      }
    },
    //获取数据
    getMapData() {
      let mapData = {},
        pointData = {},
        lineData = {},
        sum = {};
      this.timeTitle.forEach((item) => {
        mapData[item] = [];
        pointData[item] = [];
        lineData[item] = [];
        sum[item] = 0;
        var arr = this.RegionName.filter((b) => {
          return b.Year == item;
        });
        var lineArrData = this.RegionLineData.filter((d) => {
          return d.Year == item;
        });
        arr.forEach((k) => {
          mapData[item].push({
            name: k.CompanyName,
            value: k.IncomeAmount,
          });
        });

        lineArrData.forEach((c) => {
          var lineArr = c.Coordinates.split(",");

          lineData[item].push({
            coords: [
              [116.397128, 39.916527],
              [Number(lineArr[0]), Number(lineArr[1])],
            ],
            lineStyle: { color: "#00FD05" },
          });
          if (lineArr.length === 2) {
            pointData[item].push({
              name: "",
              value: [Number(lineArr[0]), Number(lineArr[1]), 1, 1],
              cityCode: "",
            });
          }
        });

        this.geoJson.features.forEach((j) => {
          var cityArr = this.cityValue.filter((b) => {
            return b.Year == item;
          });

          if (cityArr.length > 0) {
            this.maxVal = cityArr[0].CompanyCount;
          }
          var nameObj = cityArr.find((c) => {
            return c.LocationName == j.properties.name;
          });
          let value = 0;
          if (nameObj) {
            value = nameObj.CompanyCount;
          }
        });
        mapData[item] = mapData[item].sort(function (a, b) {
          return b.value - a.value;
        });
      });
      this.initEcharts(mapData, lineData, pointData, sum);
    },
    initEcharts(mapData, lineData, pointData, sum) {
      this.myChart = echarts.init(this.$refs.allMap);
      if (this.parentInfo.length === 1) {
        echarts.registerMap("china", this.geoJson); //注册
      } else {
        echarts.registerMap("map", this.geoJson); //注册
      }
      var option = {
        
        timeline: {
          data: this.timeTitle,
          axisType: "category",
          autoPlay: false,
          playInterval: 2500,
          currentIndex: 14,
          left: "10%",
          right: "10%",
          bottom: "0%",
          width: "80%",
          label: {
            normal: {
              textStyle: {
                color: "rgb(179, 239, 255)",
              },
            },
            emphasis: {
              textStyle: {
                color: "#fff",
              },
            },
          },
          symbolSize: 10,
          lineStyle: {
            color: "#8df4f4",
          },
          checkpointStyle: {
            borderColor: "#8df4f4",
            color: "#53D9FF",
            borderWidth: 2,
          },
          controlStyle: {
            showNextBtn: true,
            showPrevBtn: true,
            normal: {
              color: "#53D9FF",
              borderColor: "#53D9FF",
            },
            emphasis: {
              color: "rgb(58,115,192)",
              borderColor: "rgb(58,115,192)",
            },
          },
        },
        baseOption: {
          animation: true,
          animationDuration: 900,
          animationEasing: "cubicInOut",
          animationDurationUpdate: 900,
          animationEasingUpdate: "cubicInOut",
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
            },
          },
          grid: {
            right: "2%",
            top: "5%",
            bottom: "12%",
            width: "20%",
          },

          geo: {
            map: this.parentInfo.length === 1 ? "china" : "map",
            zoom: 1.5,
            roam: true,
            top: "15%",
            right: "12%",
            center:
              this.parentInfo.length === 1
                ? ["118.83531246", "32.0267395887"]
                : false,
            // tooltip: {
            //   trigger: "item",
            //   formatter: (p) => {
            //       console.log('[ p ] >', p)
            //     let val = p.value[2];
            //      if (p.name == '南海诸岛') return
            //     if (window.isNaN(val)) {
            //       val = 0;
            //     }
            //     let txtCon =
            //       "<div style='text-align:left'>" +
            //       p.name +
            //       ":<br />公司数量：" +
            //       val +
            //       "</div>";
            //     return txtCon;
            //   },
            // },
            label: {
              normal: {
                show: false,
                fontSize: 10,
                color: "rgb(249, 249, 249)", //省份标签字体颜色
                formatter: (p) => {
                  switch (p.name) {
                    case "内蒙古自治区":
                      p.name = "内蒙古";
                      break;
                    case "西藏自治区":
                      p.name = "西藏";
                      break;
                    case "新疆维吾尔自治区":
                      p.name = "新疆";
                      break;
                    case "宁夏回族自治区":
                      p.name = "宁夏";
                      break;
                    case "广西壮族自治区":
                      p.name = "广西";
                      break;
                    case "香港特别行政区":
                      p.name = "香港";
                      break;
                    case "澳门特别行政区":
                      p.name = "澳门";
                      break;
                    default:
                      break;
                  }
                  return p.name;
                },
              },
              emphasis: {
                show: true,
                color: "#f75a00",
              },
            },
            itemStyle: {
              normal: {
                areaColor: "#1C82FF",
                borderColor: "#165AAD",
                borderWidth: 0,
              },
              emphasis: {
                areaColor: "#8dd7fc",
                borderWidth: 1.6,
              },
            },
          },
        },
        options: [],
      };
      this.timeTitle.forEach((item) => {
        var xData = [],
          yData = [];
        mapData[item].forEach((c) => {
          xData.unshift(c.name);
          yData.unshift((c.value/10000).toFixed(2));
        });
        option.options.push({
          //  地图柱状图和颜色条  别删留着后面要是用直接放开
          //   visualMap: {
          //     // min: min,
          //     max: this.maxVal,
          //     left: "3%",
          //     bottom: "5%",
          //     calculable: false,
          //     seriesIndex: [0],
          //     inRange: {
          //       color: "#1C82FF",
          //     },
          //     textStyle: {
          //       color: "#24CFF4",
          //     },
          //   },
          //   dataZoom: [
          //     //Y轴滑动条
          //     {
          //       type: "slider", //滑动条
          //       show: true, //开启
          //       yAxisIndex: [0],
          //       left: "96%", //滑动条位置
          //       start: 100, //初始化时，滑动条宽度开始标度
          //       end: 20, //初始化时，滑动条宽度结束标度<br>
          //     },
          //     {
          //       type: "inside", //内置滑动，随鼠标滚轮展示
          //       yAxisIndex: [0],
          //       start: 20, //初始化时，滑动条宽度开始标度<br>                        end: 50  //初始化时，滑动条宽度结束标度
          //     },
          //   ],
          xAxis: {
            type: "value",
            scale: false,
            position: "top",
            boundaryGap: false,

            splitLine: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#455B77",
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              rotate: 20,
              margin: 2,
              textStyle: {
                fontSize: 8,
                color: "#c0e6f9",
              },
            },
          },
          yAxis: {
            type: "category",
            nameGap: 16,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#455B77",
              },
            },
            dataZoom: [
              //滑动条
              {
                show: false, //是否显示滑动条
                type: "slider", // 这个 dataZoom 组件是 slider 型 dataZoom 组件
                startValue: 0, // 从头开始。
                endValue: 5, // 一次性展示6个。
              },
            ],
            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              margin: 2,
              rotate: 20,
              textStyle: {
                color: "#c0e6f9",
                fontSize: 10,
              },
            },
            data: xData,
          },
          series: [
            {
              name: item + "销售额度",
              type: "map",
              geoIndex: 0,
              map: this.parentInfo.length === 1 ? "china" : "map",
              roam: false,
              zoom: 1.3,
              label: {
                normal: {
                  show: false,
                },
                emphasis: {
                  show: false,
                },
              },
              data: mapData[item],
            },
            {
              name: "散点",
              type: "custom",
              selectedMode: "single",
              coordinateSystem: "geo",
              rippleEffect: {
                brushType: "fill",
              },
              itemStyle: {
                normal: {
                  color: "#F4E925",
                  shadowBlur: 10,
                  shadowColor: "#333",
                },
              },
              renderItem(params, api) {
                //具体实现自定义图标的方法
                return {
                  type: "image",
                  style: {
                    image:
                      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAASCAYAAAEYrg+aAAAABGdBTUEAALGPC/xhBQAAAm9JREFUKBVdUstLVGEU/517R3J0JlPCHpSkRFk6lE2LIGhhtIh0aBFWusqmKYJC/4KooKjGwmgR4rSSKaIYbBZRCxdJrZoJkSlR6TXkq8lHM474ul/nfNeR8MD9vvP4nXPPOb8P+F8evR1X2lZTJ0MoDiTKMDa9oKAmfVG4/LE9iuVudNQG7bjSq8aSjRM6w90c94lChc0xVVvlRk8iDUM8vQMZENFZXUWiasrng5quL9dlJUdgHMny5RRdhMjhMYr8MS/rzkzoAIbbPKjckg+llvo1Ivgy+FDq5T6dJYeuS1T3PO5Bg7d/AMvmOZ0hhzSqJ1vxkOt8X/VqTds5N/vEW2CIs6TQRNPhEgwFqyXklCXoqcS63bANswuWqDANh9MAGU0WL6eubQgz2WUdmOnYF9dKrk2577+40y5OQ3YxfO1BSoxS1yxaa99XiO6A5ZjYXJROhRojG097eWB75/auND3KKhUk17hKG6Lf9BLFlhah6DFTdUTsnDAH70DqUqbT+0V8xABy+z/1811VzHN+vLlXY+d4pL6fWbR2JTHxd0nIS6Q7azy8qfgZBj8VVJ5JOLG/CLHvWeTnESItOxH+MIlbr0Z1EWHcYNqeEeizeNz5BrouV6B0vQPziwrtb8bR0fM7B07YWDalLZc/HuOJa3R0zUFQ8XTIe5D/oGwqZk6VZ+5d/3V099c/a7A4VjmcSgdvjIAxErMTrKVDYnRf7DIiF8IwSMEkC92BMCKBsCkxrGD0WpUK5GFqTCgrYwZkTdsFw5LkNnk++oHiTS1EHYurPEhUjdQXYJ15HMraJTY/kEHML7+mrVF57Fr+AagjCy1YN/l9AAAAAElFTkSuQmCC", // 自定义的图片地址
                    with: "15",
                    innerHeight: "15",
                    x: api.coord([
                      pointData[item][params.dataIndex].value[0] - 0.4,
                      pointData[item][params.dataIndex].value[1] - 0.5,
                    ])[0], // 数据的设置
                    y: api.coord([
                      pointData[item][params.dataIndex].value[0] + 2,
                      pointData[item][params.dataIndex].value[1],
                    ])[1],
                  },
                };
              },

              data: pointData[item],
              symbolSize: function (val) {
                let value = val[2];
                if (value == val[3]) {
                  return 12;
                }
                return 6;
              },
            },
            {
              type: "lines",
              zlevel: 2,
              effect: {
                show: true,
                period: 3, //箭头指向速度，值越小速度越快
                trailLength: 0.2, //特效尾迹长度[0,1]值越大，尾迹越长重
                symbol: "arrow", //箭头图标
                symbolSize: 4, //图标大小
              },
              lineStyle: {
                normal: {
                  color: "#ffdf38",
                  /* function (value){ //随机颜色
                        ['#f21347','#f3243e','#f33736','#f34131','#f34e2b',
                        '#f56321','#f56f1c','#f58414','#f58f0e','#f5a305',
                        '#e7ab0b','#dfae10','#d5b314','#c1bb1f','#b9be23',
                        '#a6c62c','#96cc34','#89d23b','#7ed741','#77d64c',
                        '#71d162','#6bcc75','#65c78b','#5fc2a0','#5abead',
                        '#52b9c7','#4fb6d2','#4ab2e5']
                        return "#"+("00000"+((Math.random()*16777215+0.5)>>0).toString(16)).slice(-6);}*/
                  width: 0.2, //线条宽度
                  opacity: 0.3, //尾迹线条透明度
                  curveness: 0.3, //尾迹线条曲直度
                },
              },
              data: lineData[item],
              //   [
              //     // {coords: [[116.397128, 39.916527],[117.933822456, 40.9925210525],],lineStyle: { color: "#00FD05" },},
              //     // {coords: [[116.397128, 39.916527],[79.9302386372, 37.1167744927],],lineStyle: { color: "#00FD05" },},
              //     // {coords: [[116.397128, 39.916527],[120.873800951, 32.0146645408],],lineStyle: { color: "#00FD05" },},
              //     // {coords: [[116.397128, 39.916527],[114.520486813, 37.0695311969],],lineStyle: { color: "#00FD05" },},
              //     // {coords: [[116.397128, 39.916527],[100.229628399, 26.8753510895],],lineStyle: { color: "#00FD05" },},
              //     // {coords: [[116.397128, 39.916527],[109.846238532, 40.6471194257],],lineStyle: { color: "#00FD05" },},
              //     // {coords: [[116.397128, 39.916527],[118.930761192, 42.2971123203],],lineStyle: { color: "#00FD05" },},
              //     // {coords: [[116.397128, 39.916527],[123.4379, 41.8418],],lineStyle: { color: "#00FD05" },},
              //     ],
            },
            {
              type: "bar",
              barGap: "-100%",
              tooltip: {
            trigger: "item",
            formatter: "{c}万",
          },
              barCategoryGap: "60%",
              itemStyle: {
                normal: {
                  color: function (params) {
                    // 给出颜色组
                    var colorList = [
                      "#3E9CFB",
                      "#B1D4D6",
                      "#9B73FB",
                      "#FFAF70",
                      "#1C82FF",
                      "#A5DB8A",
                      "#9CC9FF",
                      "#9CFFE8",
                      "#9CBAFF",
                      "#C67BFA",
                      "#D4D4D4",
                      "#FF7979",
                      "#FFCD79",
                      "#00F2DD",
                      "#557EF1",
                      "#89A8FF",
                      "#FFCCA3",
                      "#23C6C9",
                      "#A37AFE",
                      "#FFE799",
                      "#3E9CFB",
                      "#B1D4D6",
                      "#9B73FB",
                      "#FFAF70",
                      "#1C82FF",
                      "#A5DB8A",
                      "#9CC9FF",
                      "#9CFFE8",
                      "#9CBAFF",
                      "#C67BFA",
                      "#D4D4D4",
                      "#FF7979",
                      "#FFCD79",
                      "#00F2DD",
                      "#557EF1",
                      "#89A8FF",
                      "#FFCCA3",
                      "#23C6C9",
                      "#A37AFE",
                      "#FFE799",
                    ];
                    return colorList[params.dataIndex];
                  },
                },
              },
              data: yData,
            },
          ],
        });
      });

      this.myChart.setOption(option, false);
      this.myChart.off("click");
      //   this.myChart.on("click", this.echartsMapClick);
      //   this.myChart.on("click", (param) => {
      //       console.log('[ param ] >', param)
      //     //   .name
      //     this.$emit("yearData", param.name);
      //   });
      //监听时间切换事件
      this.myChart.off("timelinechanged");
      this.myChart.on("timelinechanged", (params) => {
        this.currentYear = option.timeline.data[params.currentIndex];
        if (this.goBack) {
          this.sliceCity = this.currentLocationId;
          this.sliceYear = this.currentYear;
          this.cityNameData();
        }

        this.$emit("yearData", this.currentYear);

        option.options.forEach((e) => {
          e.series.forEach((j) => {
            this.coordData = j.data;
            j.data.forEach((b) => {
              this.coordData = b;
            });
          });
        });
      });
    },

    isNumber(val) {
      var regPos = /^\d+(\.\d+)?$/; //非负浮点数
      var regNeg =
        /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
      if (regPos.test(val) || regNeg.test(val)) {
        return true;
      } else {
        return false;
      }
    },

    //点击下钻
    echartsMapClick(params) {
      //点击年份的时候会执行这里，判断应该是有点问题(切换年的时候必须给this.sliceYear 赋上正确的值)
      // let CurrentYear=params.name;
      this.maxVal = 0;
      var cityCode = this.cityValue.find((e) => {
        return params.name == e.LocationName;
      });

      if (this.isNumber(params.name)) {
        this.currentYear = params.name;

        if (this.currentLocationId) {
          //加载某一区域下某一年的数据
          this.sliceCity = this.currentLocationId;
          this.sliceYear = this.currentYear;
          this.cityNameData();
        }
      }

      if (!cityCode) {
        // this.$message({
        //   message: "该地区下没有公司，不可下钻！",
        //   type: "warning",
        // });
        return;
      }
      this.goBack = true;

      this.sliceCity = cityCode.LocationCode;
      this.sliceYear = this.currentYear;
      this.currentLocationId = cityCode.LocationCode;

      if (!params.data) {
        return;
      }
      if (
        this.parentInfo[this.parentInfo.length - 1].code == params.data.cityCode
      ) {
        return;
      }
      let data = params.data;

      this.parentInfo.push({
        RegionName: data.name,
        code: data.cityCode,
      });

      this.getGeoJson(data.cityCode);
    },

    cityNameData() {
      let param = {
        locationCode: this.sliceCity,
        year: this.sliceYear,
        ticket: this.urlData,
      };
      GetCompanyPerformanceByProvince(param).then((res) => {
        let mapData = {},
          pointData = {},
          sum = {};
        this.timeTitle.forEach((item) => {
          mapData[item] = [];
          pointData[item] = [];
          sum[item] = 0;
          if (res.Data) {
            var arr = res.Data.filter((b) => {
              return b.Year == item;
            });
          }
          arr.forEach((k) => {
            mapData[item].push({
              name: k.CompanyName,
              value: k.PerformanceAmount,
            });
          });
          this.geoJson.features.forEach((j) => {
            var cityData = j.properties.name.slice(0, 2);
            let value;
            for (var i = 0; i < arr.length; i++) {
              var iData = arr[i].LocationName.slice(0, 2);
              if (iData == cityData) {
                var cityData = arr.filter((e) => {
                  return e.LocationName == arr[i].LocationName;
                });

                value = cityData.length;
                if (value > this.maxVal) {
                  this.maxVal = value;
                }
                break;
              }
            }
            if (value) {
              pointData[item].push({
                name: j.properties.name,
                value: [
                  j.properties.center[0],
                  j.properties.center[1],
                  value,
                  this.maxVal,
                ],
                cityCode: j.properties.adcode,
              });
            }
          });

          mapData[item] = mapData[item].sort(function (a, b) {
            return b.value - a.value;
          });
        });

        this.initEcharts(mapData, pointData, sum);
      });
    },

    //选择切换市县
    chooseArea() {
      this.parentInfo.splice(1, 1);
      this.getGeoJson(this.parentInfo[this.parentInfo.length - 1].code);
      this.goBack = false;
      this.currentLocationId = "";
    },
  },
  //   activated() {
  //     this.getGeoJson(100000);//是不是这个地方调用一次
  //     // this.cityNameData();//然后这个地方调用一次
  //     // var that = this;
  //   },
  created() {
    this.urlData = sessionStorage.getItem("urlData");
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
html,
body,
#app {
  width: 100%;
  height: 100%;
}

[v-cloak] {
  display: none !important;
}

.echarts {
  width: 100%;
  height: 100%;
  position: relative;
  // background: url("../../../assets/img/bg1.jpg") no-repeat;
  background-size: 100% 100%;
}

.mapChoose {
  position: absolute;
  left: 20px;
  top: 55px;
  color: #eee;
  .title {
    padding: 5px;
    border-top: 1px solid rgba(147, 235, 248, 0.8);
    border-bottom: 1px solid rgba(147, 235, 248, 0.8);
    cursor: pointer;
  }

  .icon {
    font-family: "simsun";
    font-size: 25px;
    margin: 0 11px;
  }
}
</style>
<style scoped>
>>> .mapChoose .title {
  padding: 7px 12px 7px 17px !important;
  border: 1px solid #1c82ff !important;
  border-radius: 4px !important;
  display: inline-block !important;
}
>>> .mapChoose .title:hover {
  background: #1c82ff;
  border: none;
}
>>> .mapChoose {
  left: 0 !important;
  top: 0 !important;
}
@media (min-width: 1279px) and (max-width: 1365px) {
  .mapChoose .title {
    padding: 3px 8px 3px 12px !important;
    margin: 10px 0 3px 5px;
    font-size: 12px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dataChart/indexMap/indexMap.vue